import { Component, HostListener, Input } from '@angular/core';
import { Review } from '../../../model/review/review.model';

/**
 * The bottom of theme and tool pages (owner, 2026-10-04): the home page's review bubbles as a
 * wall of columns (three from 1280px, two below, one on phones) that drifts upward once every
 * column holds a few bubbles and stands still before.
 */
@Component( {
  selector: 'app-review-wall',
  templateUrl: './review-wall.component.html',
  styleUrls: [ './review-wall.component.scss' ],
} )
export class ReviewWallComponent {

  /** the page's own reviews: the bubbles leave out the theme / tool pill, the page already says whose they are */
  @Input() set reviews( value: Review[] ) {
    this.bubbles = ( value || [] ).map( r => ( { ...r, theme: undefined, themeLogo: undefined } ) );
  }

  bubbles: Review[] = [];
  @Input() label = 'Reviews';
  /** tool pages (owner, 2026-10-04): the bubbles in the site's own theme (Appearance), not a color of the page */
  @Input() system = false;

  private colCount = ReviewWallComponent.colsFor();
  private dealtFor: Review[] | null = null;
  private dealt: Review[][] = [];

  /** the bubbles dealt in turn into the columns of a wide screen */
  get columns(): Review[][] {
    const count = Math.max( 1, Math.min( this.colCount, this.bubbles.length ) );
    if ( this.dealtFor !== this.bubbles || this.dealt.length !== count ) {
      this.dealtFor = this.bubbles;
      const cols: Review[][] = Array.from( { length: count }, () => [] );
      this.bubbles.forEach( ( r, i ) => cols[ i % count ].push( r ) );
      this.dealt = cols;
    }
    return this.dealt;
  }

  /** wide screens drift from three bubbles a column (two would leave a gap in the loop) */
  get moves(): boolean {
    return this.bubbles.length >= 3 * this.colCount;
  }

  /** phones: one column, which three bubbles already fill */
  get singleMoves(): boolean {
    return this.bubbles.length >= 3;
  }

  @HostListener( 'window:resize' )
  onResize(): void {
    this.colCount = ReviewWallComponent.colsFor();
  }

  trackByReview( index: number, review: Review ): string {
    return review.reviewer + review.date + index;
  }

  /** three columns from 1280px (xl), two below it, where the content is too narrow for three */
  private static colsFor(): number {
    return typeof window !== 'undefined' && window.innerWidth < 1280 ? 2 : 3;
  }
}
